export default {
    name: 'BacklinksIpSelector',
    props: {
        path: {
            type: String,
            required: true,
        },
        domain: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            viewMode: null,
            options: [
                {label: this.$t('lang.report.backlinks_ip.view_all'), value: ''},
                {label: this.$t('lang.report.backlinks_ip.view_subnet'), value: '&subnet=1'},
            ],
        }
    },
    methods: {
        onChangeMode() {
            window.open(sprintf('%s?domain=%s%s', this.path, this.domain, this.viewMode), '_self');
        },
    },
}
